export const AccessControlStore = {
  getDeniedContext: () => {
    try {
      return JSON.parse(sessionStorage.getItem('deniedContext') || 'null');
    } catch {
      return null;
    }
  },
  setDeniedContext: (context: any) => {
    sessionStorage.setItem('deniedContext', JSON.stringify(context));
  },
  clearDeniedContext: () => {
    sessionStorage.removeItem('deniedContext');
  }
};
